import { useState } from "react";
import { useAuth, formatAuthError } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock, Mail, LogIn, ShieldCheck } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim(), password);
      // AuthProvider akan otomatis re-render App ke dashboard
    } catch (ex) {
      setErr(formatAuthError(ex));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-zinc-100 to-zinc-50 px-4"
         data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-sm bg-[#E65100] text-white grid place-items-center font-bold">GA</div>
            <div className="text-left">
              <div className="font-bold text-lg tracking-tight">GLOBAL AC</div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-500">Otomasi AI system</div>
            </div>
          </div>
        </div>

        <form onSubmit={submit}
              className="bg-white border border-border rounded-sm p-8 space-y-4 shadow-sm"
              data-testid="login-form">
          <div className="flex items-center gap-2 pb-2 border-b border-border">
            <ShieldCheck className="w-4 h-4 text-[#E65100]" />
            <div className="text-[10px] uppercase tracking-widest font-semibold text-zinc-600">Masuk Ops Console</div>
          </div>

          <div>
            <label className="text-[11px] uppercase tracking-widest font-semibold text-zinc-500">Email</label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-zinc-400" />
              <Input type="email" required autoFocus autoComplete="username"
                value={email} onChange={e=>setEmail(e.target.value)}
                placeholder="admin@globalac.co.id"
                className="rounded-sm pl-9" data-testid="login-email-input" />
            </div>
          </div>

          <div>
            <label className="text-[11px] uppercase tracking-widest font-semibold text-zinc-500">Password</label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-zinc-400" />
              <Input type="password" required autoComplete="current-password"
                value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="Kata sandi"
                className="rounded-sm pl-9" data-testid="login-password-input" />
            </div>
          </div>

          {err && (
            <div className="text-[12px] text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2"
                 data-testid="login-error">
              {err}
            </div>
          )}

          <Button type="submit" disabled={busy || !email || !password}
            className="w-full bg-[#E65100] hover:bg-[#F57C00] rounded-sm gap-1.5"
            data-testid="login-submit-btn">
            <LogIn className="w-4 h-4" />
            {busy ? "Memproses…" : "Masuk"}
          </Button>

          <div className="text-[10px] text-zinc-400 text-center pt-2 border-t border-border">
            Halaman ini terbatas untuk admin GLOBAL AC. Hubungi super-admin jika lupa password.
          </div>
        </form>
      </div>
    </div>
  );
}
